import { DownloadBlob } from '@browser/Browser';
import { isNullOrWhitespace, roundDecimal, strCompareLowerCase } from '@common/Common';
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { dynamicUiRoutes } from '@common/dynamicUiRoutes';
import PanelistConsistencyAnalysisDialog from '@Evaluation/AlternativesSurveys/Components/PanelistConsistencyAnalysisDialog.vue';
import { ScoringPanelistsManagerViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoringPanelistsManager';
import ScoringPanelistsManager from '@Evaluation/AlternativesSurveys/Components/ScoringPanelistsManager.vue';
import { ScoringSurveyAccessLinksViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyAccessLinks';
import ScoringSurveyAccessLinks from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyAccessLinks.vue';
import { ScoringSurveyEmailSenderViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyEmailSender';
import ScoringSurveyEmailSender from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyEmailSender.vue';
import { ChangeScoringPanelistVoteStrengthCommandV1, ExcludeScoringPanelistCommandV1, IncludeScoringPanelistCommandV1, SendEmailCommandV1 } from '@Evaluation/AlternativesSurveys/Domain/commands-core';
import ScoringCommands from '@Evaluation/AlternativesSurveys/Domain/commands-vue-component';
import ScoringQueries from '@Evaluation/AlternativesSurveys/Domain/queries-vue-component';
import { PanelistConsistencyAnalysisReadModel, ScoringDownloadAccessLinksReadModel, ScoringPanelistReadModel, ScoringPanelistsManagerReadModel, ScoringPanelistsPageReadModel, ScoringSurveyPanelistsReadModel } from "@Evaluation/AlternativesSurveys/Domain/readmodels";
import ConsistencyAnalysisCircles from '@Evaluation/Common/Components/ConsistencyAnalysisCircles.vue';
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { Component, mixins } from 'vue-facing-decorator';
 

@Component({
    components: { PortfolioOrDecisionNavigation, ConsistencyAnalysisCircles, PanelistConsistencyAnalysisDialog, ScoringPanelistsManager, ScoringSurveyAccessLinks, ScoringSurveyEmailSender }
})
export default class ScoringPanelistsPage extends mixins(ScoringCommands, ScoringQueries) {

    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get projectId(): number { return Number(this.$route?.params?.projectId ?? 0); }
    get evalModelId(): number { return Number(this.$route?.params?.evalModelId ?? 0); }
    get surveyId(): number { return Number(this.$route?.params?.surveyId ?? 0); }

    Initialized: boolean = false;
    tags: string[] = null;

    tagFilter: string = null; 
    progressFilter: string = null;

    SurveyName: string;
    SearchPhrase: string = null;
    Panelists: ScoringPanelistReadModel[] = null;

    Progress: number = null;

    panelistConsistencyAnalysis: PanelistConsistencyAnalysisReadModel = null;
    panelistConsistencyAnalysisOpened: boolean = false;

    scoringPanelistsManager: ScoringPanelistsManagerViewModel | null = null; 
    scoringSurveyAccessLinks = new ScoringSurveyAccessLinksViewModel();
    scoringSurveyEmailSender = new ScoringSurveyEmailSenderViewModel();

    get PanelistsView(): ScoringPanelistReadModel[]
    {
        let view = new Array(...this.Panelists);

        if (!isNullOrWhitespace(this.SearchPhrase))
        {
            const phrase = this.SearchPhrase.toLowerCase();
            view = view.filter(a => a.Name.toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.progressFilter)
        {
            if (this.progressFilter === 'Not started')
            {
                view = view.filter(a => a.Progress === 0);
            }
            else if (this.progressFilter === 'In progress')
            {
                view = view.filter(a => a.Progress > 0 && a.Progress < 100);
            }
            else if (this.progressFilter === 'Completed')
            {
                view = view.filter(a => a.Progress === 100);
            }
        }

        if (this.tagFilter)
        {
            view = view.filter(a => a.Tags.indexOf(this.tagFilter) > -1);
        }

        view = view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));

        return view;
    }

    get NonePanelistsSelected(): boolean { return this.Panelists.some(a => a.Selected) === false; }
    get AnyPanelistsSelected(): boolean { return this.Panelists.some(a => a.Selected); }
    get AllPanelistsSelected(): boolean { return this.Panelists.length > 0 && this.Panelists.some(a => a.Selected === false) === false; }
    get SelectedPanelistsCount(): number { return this.Panelists.filter(a => a.Selected === true).length; }

    get FilterLabel(): string 
    {
        if (this.tagFilter)
        {
            return this.tagFilter;
        }

        if (this.progressFilter)
        {
            return this.progressFilter;
        }

        return "All panelists";
    }

    get url_ScoringPanelsPage(): string
    {
        return dynamicUiRoutes.Evaluation_ScoringPanelsPage(this.$route, this.workspaceId, this.projectId, this.evalModelId);
    }


    showPanelistConsistencyAnalysis(projectUserId: number)
    {
        this.panelistConsistencyAnalysis = null;
        this.panelistConsistencyAnalysisOpened = true;
        this.runPanelistConsistencyAnalysisQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId, projectUserId);
    }


    filterByProgress(filter: string)
    {
        this.tagFilter = null;
        this.progressFilter = filter;
    }

    filterByTag(t: string)
    {
        this.progressFilter = null;
        this.tagFilter = t;
    }

    resetFilters()
    {
        this.progressFilter = null;
        this.tagFilter = null;
    }


    AddPanelistsCommand()
    {
        this.runScoringPanelistsManagerQueryV1(this.workspaceId, this.surveyId);
        this.scoringPanelistsManager.show(this.surveyId);
    }

    EmailManyCommand()
    {
        const puIds = this.Panelists.filter(a => a.Selected === true && a.HasEmail).map(a => a.ProjectUserId);
        this.scoringSurveyEmailSender.show(this.surveyId, puIds);
    }

    DownloadLinksCommand()
    {
        this.scoringSurveyAccessLinks.show(this.surveyId);
        this.runScoringAccessLinksBySurveyIdQueryV1(this.workspaceId, this.surveyId);
    }


    SelectAllCommand()
    {
        this.PanelistsView.forEach(a => a.Selected = true);
    }

    UnselectAllCommand()
    {
        this.PanelistsView.forEach(a => a.Selected = false);
    }

    InverseSelectionCommand()
    {
        this.PanelistsView.forEach(a => a.Selected = !a.Selected);
    }



    EmailOneCommand(p: ScoringPanelistReadModel)
    {
        if (p.HasEmail)
        {
            this.scoringSurveyEmailSender.show(this.surveyId, [p.Id]);
        }
        else
        {
            alert("Email not provided");
        }
    }

    handleShowEmailSender(surveyId: number, puIds: number[])
    {
        this.scoringSurveyEmailSender.show(this.surveyId, puIds);
    }

    handleDownloadAccessLinks(surveyId: number)
    {
        this.runExportScoringAccessLinksBySurveyIdQueryV1(this.workspaceId, surveyId);
    }

    handleSendEmailCommand(emailSubject: string, emailBody: string)
    {
        const sender = this.scoringSurveyEmailSender;
        this.invokeSendEmailCommandV1(this.workspaceId, this.surveyId, sender.projectUserIds, emailSubject, emailBody);
    }


    handleExcludePanelistsCommand(p: ScoringPanelistReadModel)
    {
        this.invokeExcludeScoringPanelistCommandV1(this.workspaceId, this.surveyId, p.Id);
    }

    handleChangeCriteriaPanelistVoteStrengthCommand(p: ScoringPanelistReadModel, vs: number)
    {
        this.invokeChangeScoringPanelistVoteStrengthCommandV1(this.workspaceId, this.surveyId, p.Id, p.VoteStrength, vs);
    }

    handleIncludeScoringPanelistCommand(puId: number)
    {
        this.invokeIncludeScoringPanelistCommandV1(this.workspaceId, this.surveyId, puId);
    }


    mounted()
    {
        document.title = "Panelists | TransparentChoice";

        this.scoringPanelistsManager = new ScoringPanelistsManagerViewModel(this.workspaceId, this.projectId);

        this.runScoringPanelistsPageQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "ScoringPanelistsPageReadModel")
        {
            const rm = model as ScoringPanelistsPageReadModel;

            this.tags = rm.ProjectUsersTags;
            this.SurveyName = rm.Survey.SurveyName;
            this.Panelists = rm.Survey.Panelists;
            this.Progress = rm.Progress != null ? roundDecimal(rm.Progress, 0) : null;

            this.Initialized = true;
        }
        else if (modelName == "ScoringPanelistReadModel")
        {
            const panelist = model as ScoringPanelistReadModel;
            this.Panelists = this.Panelists.filter(a => a.Id !== panelist.Id);
            this.Panelists.push(panelist);
        }
        else if (modelName == "PanelistConsistencyAnalysisReadModel")
        {
            this.panelistConsistencyAnalysis = model as PanelistConsistencyAnalysisReadModel;
        }
        if (modelName == "ScoringPanelistsManagerReadModel")
        {
            const rm = model as ScoringPanelistsManagerReadModel;
            this.scoringPanelistsManager.setData(rm);
        }
        else if (modelName == "ScoringSurveyPanelistsReadModel")
        {
            const rm = model as ScoringSurveyPanelistsReadModel;
            this.scoringSurveyAccessLinks.setData(rm);
        }
        else if (modelName === "ScoringDownloadAccessLinksReadModel")
        {
            const rm = model as ScoringDownloadAccessLinksReadModel;
            DownloadBlob(rm.Url);
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string)
    {
        if (IncludeScoringPanelistCommandV1.matchType(cmd))
        {
            const projectUserId = Number.parseInt(correlationId);
            this.runScoringPanelistQueryV1(this.workspaceId, this.surveyId, projectUserId);
            this.scoringPanelistsManager.setIncluded(projectUserId);
        }
        else if (ExcludeScoringPanelistCommandV1.matchType(cmd))
        {
            const projectUserId = Number.parseInt(correlationId);
            this.Panelists = this.Panelists.filter(a => a.ProjectUserId !== projectUserId);
        }
        else if (ChangeScoringPanelistVoteStrengthCommandV1.matchType(cmd))
        {
            const projectUserId = Number.parseInt(correlationId);
            this.runScoringPanelistQueryV1(this.workspaceId, this.surveyId, projectUserId);
        }
        else if (SendEmailCommandV1.matchType(cmd))
        {
            alert("Sent");
            this.scoringSurveyEmailSender.close();
        }
    }
}